const BREAKPOINTS = {
  xs: 0,
  s: 320,
  m: 768,
  l: 1280,
  xl: 1920,
}

export { BREAKPOINTS }